var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 24H28V40H38C39.1046 40 40 39.1046 40 38V26C40 24.8954 39.1046 24 38 24ZM24 20V44H38C41.3137 44 44 41.3137 44 38V26C44 22.6863 41.3137 20 38 20H24Z",
    fill: "url(#paint0_linear_1215_4862)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 30C36 28.8954 35.1046 28 34 28C32.8954 28 32 28.8954 32 30C32 31.1046 32.8954 32 34 32C35.1046 32 36 31.1046 36 30Z",
    fill: "url(#paint1_linear_1215_4862)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 36C36 34.8954 35.1046 34 34 34C32.8954 34 32 34.8954 32 36C32 37.1046 32.8954 38 34 38C35.1046 38 36 37.1046 36 36Z",
    fill: "url(#paint2_linear_1215_4862)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 44C6.68629 44 4 41.3137 4 38V10C4 6.68629 6.68629 4 10 4H22C25.3137 4 28 6.68629 28 10V44H10ZM10 8H22C23.1046 8 24 8.89543 24 10V40H20V38C20 36.8954 19.1046 36 18 36H14C12.8954 36 12 36.8954 12 38V40H10C8.89543 40 8 39.1046 8 38V10C8 8.89543 8.89543 8 10 8Z",
    fill: "url(#paint3_linear_1215_4862)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C19.1046 12 20 12.8954 20 14C20 15.1046 19.1046 16 18 16H14C12.8954 16 12 15.1046 12 14C12 12.8954 12.8954 12 14 12H18Z",
    fill: "url(#paint4_linear_1215_4862)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20C19.1046 20 20 20.8954 20 22C20 23.1046 19.1046 24 18 24H14C12.8954 24 12 23.1046 12 22C12 20.8954 12.8954 20 14 20H18Z",
    fill: "url(#paint5_linear_1215_4862)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30C20 28.8954 19.1046 28 18 28H14C12.8954 28 12 28.8954 12 30C12 31.1046 12.8954 32 14 32H18C19.1046 32 20 31.1046 20 30Z",
    fill: "url(#paint6_linear_1215_4862)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1215_4862",
    x1: 30.1745,
    y1: 25.92,
    x2: 39.5154,
    y2: 28.8325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1215_4862",
    x1: 33.2349,
    y1: 30.4667,
    x2: 35.2398,
    y2: 30.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1215_4862",
    x1: 33.2349,
    y1: 30.4667,
    x2: 35.2398,
    y2: 30.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1215_4862",
    x1: 7.04615,
    y1: 7.38461,
    x2: 34.3071,
    y2: 25.5396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1215_4862",
    x1: 13.0154,
    y1: 13.6923,
    x2: 23.9727,
    y2: 18.5571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1215_4862",
    x1: 13.0154,
    y1: 13.6923,
    x2: 23.9727,
    y2: 18.5571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1215_4862",
    x1: 13.0154,
    y1: 13.6923,
    x2: 23.9727,
    y2: 18.5571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8951"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.5397a229ae0bf8e9ed6a7d89ac6f18ac.svg";
export { ForwardRef as ReactComponent };